import { LinkButton } from "$components/button/link-button";
import { ArrowBackIcon } from "$components/icons";
import { styled } from "@material-ui/core";
import type { FC } from "react";
import { FormattedMessage, type MessageDescriptor } from "react-intl";

const StyledBackButton = styled(LinkButton)({
  "&.MuiButton-root": {
    paddingBlock: 0,
  },
});

const StyledBackNavigationButton = styled(LinkButton)(({ theme }) => ({
  "&.MuiButton-root": {
    paddingBlock: 0,
    marginBottom: 0, // No bottom margin for tight spacing
    marginLeft: 0, // No left margin - natural positioning
    display: "inline-flex",
    alignItems: "center",
  },
}));

const StyledArrowBackIcon = styled(ArrowBackIcon)({
  width: 16,
  height: 16,
});

type BackButtonProps = {
  to: string;
  variant?: "text" | "outlined" | "contained";
  replace?: boolean;
  className?: string;
  "data-testid"?: string;
  children: React.ReactNode;
};

export const BackButton: FC<BackButtonProps> = ({
  to,
  variant = "text",
  replace = false,
  className,
  children,
  ...props
}) => {
  return (
    <StyledBackButton
      variant={variant}
      to={to}
      replace={replace}
      className={className}
      {...props}
    >
      {children}
    </StyledBackButton>
  );
};

type BackNavigationButtonProps = {
  to: string;
  label: MessageDescriptor;
  dataTestId?: string;
};

export const BackNavigationButton: FC<BackNavigationButtonProps> = ({
  to,
  label,
  dataTestId,
}) => {
  return (
    <StyledBackNavigationButton
      variant="text"
      to={to}
      replace={false}
      data-testid={dataTestId}
      startIcon={<StyledArrowBackIcon />}
    >
      <FormattedMessage {...label} />
    </StyledBackNavigationButton>
  );
};
